import { render, staticRenderFns } from "./alerts_table.vue?vue&type=template&id=000fc908&scoped=true&"
import script from "./alerts_table.vue?vue&type=script&lang=js&"
export * from "./alerts_table.vue?vue&type=script&lang=js&"
import style0 from "./alerts_table.vue?vue&type=style&index=0&id=000fc908&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000fc908",
  null
  
)

export default component.exports